import {Box, Typography} from '@mui/material';
import {useEntity} from '../../contexts/entity/context';

type OccurrencesCountProps = {
  isActive?: boolean;
};

export const OccurrencesCount = ({isActive}: OccurrencesCountProps) => {
  const {state: entityState} = useEntity();

  if (entityState.occurrencesCount > 0) {
    return (
      <Box
        sx={{
          backgroundColor: isActive === false ? 'var(--dcm-red-base)' : 'var(--dcm-red)',
          borderRadius: '50%',
          position: 'absolute',
          right: isActive === undefined ? '-2px' : '4px',
          height: '14px',
          width: '14px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography
          sx={{
            fontSize: '8px',
            lineHeight: '12px',
            fontWeight: '500',
            color: 'white',
          }}
        >
          {entityState.occurrencesCount}
        </Typography>
      </Box>
    );
  }
  return null;
};
